import React from 'react';

interface ButtonSlimProps {
  children: React.ReactNode;
  className?: string;
  onClick?: () => void;
  color?: string | "clay";
  disabled?: boolean;
  type?: 'button' | 'submit' | 'reset';
}

const ButtonSlim: React.FC<ButtonSlimProps> = ({ 
  children, 
  className = '', 
  onClick, 
  color = 'moss',
  disabled = false,
  type = 'button'
}) => {
  return (
    <button
      type={type}
      onClick={onClick}
      className={`inline-block h-[38px] px-4 bg-muted-${color} bg-opacity-80 text-muted-black border border-muted-darkGrey rounded-[10px] shadow-[3px_3px_0_-2px_theme(colors.muted.darkGrey)] hover:bg-opacity-40 hover:text-muted-black hover:shadow-[6px_6px_0_-2px_theme(colors.muted.darkGrey)] transition-all ${className} ${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
    >
      {children}
    </button>
  );
};

export default ButtonSlim; 